const list = [
  { id: 1, label: '百度PC', queryUrl: 'https://www.baidu.com/s?wd=' },
  { id: 2, label: '百度移动', queryUrl: 'https://m.baidu.com/s?wd=' },
  { id: 3, label: '360', queryUrl: 'https://www.so.com/s?q=' },
  { id: 4, label: '搜狗', queryUrl: 'https://www.sogou.com/web?query=' },
  { id: 5, label: '神马', queryUrl: 'https://m.sm.cn/s?q=' },
  { id: 6, label: '必应', queryUrl: 'https://cn.bing.com/search?q=' }
]

const getLabelById = (id) => {
  const item = list.find(item => item.id === id)
  return item ? item.label : ''
}

const getQueryUrl = (id, keyword) => {
  const item = list.find(item => item.id === id)
  if (item) {
    return item.queryUrl + keyword
  } else {
    return ''
  }
}

export default {
  list,
  getLabelById,
  getQueryUrl
}
